/* import __COLOCATED_TEMPLATE__ from './trigger-info-node-content-header.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();